export default __webpack_public_path__ + "static/Peanut-Butter-a1ec857163f10ce7fd5fa0e7930eb824.webp";